export default __webpack_public_path__ + "static/media/Height_lock.ba237419.svg";